import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Lazy } from "swiper";
import { normalizeString } from "../../helpers/normalizeString";
import priceToMonedaElegida from "../../helpers/priceToMonedaElegida";
import colores from "../../helpers/colores";
import "swiper/css/lazy";
import Swal from "sweetalert2";
import axios from "axios";
import useHeaders from "../../../hooks/useHeaders";
import { ImagenListon } from "../../ImagenListon";
import numberToCommas from "../../helpers/numberToCommas";
import { useWindowDimension } from "../../../hooks/useWindowDimension";
import getTotalReservaFinal from "../../detailedScreens/getTotalReservaFinal";
import { getPreciosAdicionales } from "../../alquilerScreen/alquilerAlojamiento/getPreciosAdicionales";
import { calcularDescuentoPrecioFinal } from "../../alquilerScreen/alquilerAlojamiento/calcularDescuentoPrecioFinal";
import getTotalReservaInicial from "../../detailedScreens/getTotalReservaInicial";
import { useSelector } from "react-redux";
import { getGarantiaTotal } from "../../alquilerScreen/alquilerAlojamiento/getGarantiaTotal";

const CardsDestacados = ({
    product,
    vistaAdministrador,
    setRefreshHouses,
    setSelectedMarker,
    setMapShouldFly,
    selectedDays,
    personas,
    cantDays,
}) => {
    const moneda_elegida = localStorage.getItem("moneda");
    const { headers } = useHeaders();
    const [windowWidth, windowsHeight] = useWindowDimension();
    const authUser = useSelector((state) => state.authReducer);
    const deleteImage = (house_id, house_name) => {
        Swal.fire({
            title: `¿Seguro que quieres eliminar ${house_name} de la promo?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, eliminar!",
            cancelButtonText: "No, mejor no",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { data } = await axios.delete(
                        `${process.env.REACT_APP_PROXY}/casasSemanaSanta/eliminar/${house_id}`,
                        { headers }
                    );

                    setRefreshHouses((prev) => !prev);
                } catch (error) {
                    console.log(error.response);
                }
            }
        });
    };

    const atributos = product.atributos
        ? product.atributos.split(", ").slice(0, 3)
        : [];

    return (
        <div
            id={product.id}
            key={product.id}
            className="relative mt-2 select-none md723:flex md:mt-0"
        >
            <div className="relative w-full md723:max-w-sm h-[232px] flex">
                <Swiper
                    modules={[Navigation, Lazy]}
                    slidesPerView={1}
                    watchSlidesProgress
                    lazy={true}
                    // navigation
                    pagination
                    spaceBetween={100}
                    rewind={true}
                    loop={true}
                >
                    <SwiperSlide
                        className="w-full cursor-pointer"
                        onMouseEnter={() => {
                            setMapShouldFly(true);
                            setSelectedMarker(product);
                        }}
                        onClick={() =>
                            window.open(
                                `/alojamientos/${product.id}/${normalizeString(
                                    product.nombre
                                )}`,
                                "_blank"
                            )
                        }
                    >
                        <ImagenListon
                            loading="lazy"
                            className="object-cover w-full h-[232px] rounded-md swiper-lazy"
                            alt="Imagen del producto"
                            dataSrc={`${process.env.REACT_APP_PROXY_ARCHIVOS}/bluecorner/v1/casa/getImagenPrincipal/${product.imagen_principal_minificada}`}
                            dataSrcSet={`${process.env.REACT_APP_PROXY_ARCHIVOS}/bluecorner/v1/casa/getImagenPrincipal/${product.imagen_principal_minificada}`}
                            listonText="Destacado"
                            mostrarListon={false}
                        />

                        <div className="swiper-lazy-preloader">
                            <div className="flex flex-col w-full h-[232px] gap-2 p-3 bg-gray-200">
                                <div className="bg-slate-50 w-full h-[80%] rounded-md"></div>
                                <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                            </div>
                        </div>
                    </SwiperSlide>
                    {product.imagenes.map((imagen) => (
                        <SwiperSlide
                            key={imagen.id}
                            onClick={() =>
                                window.open(
                                    `/alojamientos/${
                                        product.id
                                    }/${normalizeString(product.nombre)}`,
                                    "_blank"
                                )
                            }
                        >
                            <ImagenListon
                                loading="lazy"
                                className="object-cover w-full h-[212px] rounded-md swiper-lazy"
                                alt="Imagen del producto"
                                dataSrc={`${process.env.REACT_APP_PROXY_ARCHIVOS}/bluecorner/v1/productoImagenes/getImagen/${imagen.imagen_minificada}`}
                                dataSrcSet={`${process.env.REACT_APP_PROXY_ARCHIVOS}/bluecorner/v1/productoImagenes/getImagen/${imagen.imagen_minificada}`}
                                listonText="Destacado"
                                mostrarListon={false}
                            />

                            <div className="swiper-lazy-preloader">
                                <div className="flex flex-col w-full h-[212px] gap-2 p-3 bg-gray-200">
                                    <div className="bg-slate-50 w-full h-[80%] rounded-md"></div>
                                    <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                    <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div
                className={`ml-4 py-2 w-full  ${
                    vistaAdministrador ? "cursor-move" : ""
                } `}
            >
                {selectedDays.length > 0 && (
                    <div className="flex flex-col justify-start items-start text-[#053465] gap-1 md723:hidden md723:absolute bottom-2 ">
                        <span className="font-bold 3xl:text-sm text-xs italic">
                            (precio referencial)
                        </span>
                        <div className="flex justify-center items-center">
                            <span className="font-bold 3xl:text-3xl lg:text-2xl">
                                {moneda_elegida === "PEN" ? "S/" : "$"}{" "}
                                {numberToCommas(
                                    getTotalReservaFinal(
                                        cantDays + 1,
                                        selectedDays,
                                        {
                                            ...product,
                                            huespedes: personas,
                                        },
                                        getPreciosAdicionales({
                                            ...product,
                                            huespedes: personas,
                                        }),
                                        authUser.tipo_usuario === 6 ||
                                            authUser.tipo_usuario === 7,
                                        getGarantiaTotal,
                                        authUser.membresia,
                                        true
                                    ) -
                                        calcularDescuentoPrecioFinal(
                                            getTotalReservaInicial(
                                                cantDays + 1,
                                                selectedDays,
                                                {
                                                    ...product,
                                                    huespedes: personas,
                                                }
                                            ),
                                            product.oferta_activada,
                                            product.oferta
                                        ) -
                                        getTotalReservaInicial(
                                            cantDays + 1,
                                            selectedDays,
                                            {
                                                ...product,
                                                huespedes: personas,
                                            },
                                            true
                                        )
                                )}
                            </span>
                            <span className="lg:text-base 3xl:text-lg">
                                / Por {cantDays} noches
                            </span>
                        </div>
                    </div>
                )}

                <div
                    className={` text-lg  flex flex-col-reverse md723:flex-row md723:justify-between md723:items-center`}
                >
                    <a
                        href={`/alojamientos/${product.id}/${normalizeString(
                            product.nombre
                        )}`}
                        className="cursor-pointer"
                    >
                        <div className="capitalize text-[#053465] font-bold xl:text-xl 3xl:text-2xl mt-1">
                            {product.nombre}
                        </div>
                    </a>
                    <div className="flex items-center justify-start mt-3 ">
                        <svg
                            className="w-5 h-5"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.98249 5.28968C9.17394 5.28968 8.38353 5.52945 7.71124 5.97866C7.03895 6.42787 6.51496 7.06635 6.20554 7.81336C5.89612 8.56037 5.81516 9.38236 5.9729 10.1754C6.13065 10.9684 6.52 11.6968 7.09174 12.2686C7.66348 12.8403 8.39191 13.2297 9.18494 13.3874C9.97796 13.5452 10.7999 13.4642 11.547 13.1548C12.294 12.8454 12.9324 12.3214 13.3817 11.6491C13.8309 10.9768 14.0706 10.1864 14.0706 9.37782C14.0679 8.29441 13.6364 7.25614 12.8703 6.49005C12.1042 5.72396 11.0659 5.29238 9.98249 5.28968ZM9.98249 11.8307C9.49736 11.8307 9.02312 11.6869 8.61974 11.4173C8.21637 11.1478 7.90198 10.7647 7.71632 10.3165C7.53067 9.8683 7.48209 9.3751 7.57674 8.89929C7.67138 8.42348 7.905 7.98641 8.24804 7.64337C8.59108 7.30033 9.02815 7.06672 9.50396 6.97207C9.97977 6.87743 10.473 6.926 10.9212 7.11165C11.3694 7.29731 11.7525 7.6117 12.022 8.01507C12.2915 8.41845 12.4354 8.89269 12.4354 9.37782C12.4327 10.0275 12.1734 10.6499 11.714 11.1093C11.2545 11.5687 10.6322 11.828 9.98249 11.8307ZM9.98249 0.383911C7.59799 0.386616 5.31192 1.33506 3.62582 3.02116C1.93972 4.70725 0.991284 6.99332 0.988579 9.37782C0.988579 12.587 2.47053 15.9904 5.28113 19.2098C6.54453 20.6681 7.96334 21.9841 9.51236 23.1344C9.65162 23.2271 9.81519 23.2766 9.98249 23.2766C10.1498 23.2766 10.3134 23.2271 10.4526 23.1344C12.0062 21.9858 13.4285 20.6697 14.6941 19.2098C17.4945 15.9904 18.9764 12.587 18.9764 9.37782C18.9737 6.99332 18.0253 4.70725 16.3392 3.02116C14.6531 1.33506 12.367 0.386616 9.98249 0.383911ZM9.98249 21.4378C8.29614 20.1092 2.62384 15.2239 2.62384 9.37782C2.62384 7.42619 3.39912 5.55448 4.77914 4.17447C6.15915 2.79445 8.03086 2.01917 9.98249 2.01917C11.9341 2.01917 13.8058 2.79445 15.1859 4.17447C16.5659 5.55448 17.3412 7.42619 17.3412 9.37782C17.3412 15.2239 11.6689 20.1092 9.98249 21.4378Z"
                                fill="#0F80F2"
                            />
                        </svg>
                        <div className="capitalize text-[#0F80F2] text-sm xl:text-base 3xl:text-lg ">
                            {product.ciudad}, {product.departamento}
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap items-center justify-start gap-2 mt-4 capitalize">
                    <div className="flex items-center justify-start gap-1">
                        <svg
                            className="w-4 h-4"
                            viewBox="0 0 15 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_90_195)">
                                <path
                                    d="M9.43419 7.27982C10.4724 6.6331 11.1649 5.48141 11.1649 4.17074C11.1649 2.1524 9.5229 0.510376 7.50455 0.510376C5.4862 0.510376 3.84419 2.1524 3.84419 4.17074C3.84419 5.48141 4.53666 6.63299 5.57481 7.27971C3.36919 8.07297 1.78769 10.1856 1.78769 12.661V14.7299C1.78769 14.9748 1.98626 15.1733 2.23114 15.1733H12.7777C13.0226 15.1733 13.2211 14.9748 13.2211 14.7299V12.661C13.2211 10.1857 11.6397 8.0732 9.43419 7.27982ZM12.3343 14.2864H2.67459V12.661C2.67459 9.9978 4.84117 7.83122 7.50444 7.83122C10.1676 7.83122 12.3343 9.9978 12.3343 12.661V14.2864ZM10.278 4.17074C10.278 5.70011 9.03392 6.94432 7.50455 6.94432C5.97519 6.94432 4.73109 5.70011 4.73109 4.17074C4.73109 2.64149 5.97519 1.39728 7.50455 1.39728C9.03392 1.39728 10.278 2.64149 10.278 4.17074Z"
                                    fill="#0F80F2"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_90_195">
                                    <rect
                                        width="14.6629"
                                        height="14.6629"
                                        fill="white"
                                        transform="translate(0.183975 0.510376)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <div className="text-[#262525] text-xs 3xl:text-sm">
                            {product.numero_personas} Personas
                        </div>
                    </div>

                    <div className="flex items-center justify-start gap-1">
                        <svg
                            className="w-4 h-4"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_90_199)">
                                <path
                                    d="M15.3274 10.3902C15.35 10.3298 15.358 10.2632 15.3372 10.196L14.1293 6.27056V2.64884C14.1293 1.80695 13.4444 1.12146 12.6019 1.12146H3.43758C2.59506 1.12146 1.9102 1.80695 1.9102 2.64884V6.27059L0.70234 10.196C0.681577 10.2625 0.68951 10.3292 0.712105 10.3902C0.697443 10.455 0.688278 10.5216 0.688278 10.5913V13.0351V14.257C0.688278 14.4256 0.825142 14.5625 0.993766 14.5625H2.21569C2.38428 14.5625 2.52115 14.4256 2.52115 14.257V13.3406H13.5184V14.257C13.5184 14.4256 13.6552 14.5625 13.8238 14.5625H15.0458C15.2144 14.5625 15.3513 14.4256 15.3513 14.257V13.0351V10.5913C15.3512 10.5216 15.3421 10.455 15.3274 10.3902ZM2.52115 2.64884C2.52115 2.14357 2.93231 1.73241 3.43758 1.73241H12.6019C13.1072 1.73241 13.5184 2.14357 13.5184 2.64884V6.00909H12.6881L12.4034 4.87028C12.3007 4.46155 11.9348 4.17622 11.5138 4.17622H9.54713C9.04186 4.17622 8.6307 4.58739 8.6307 5.09266V6.00909H7.40878V5.09326C7.40878 4.58799 6.99761 4.17682 6.49234 4.17682H4.52568C4.10472 4.17682 3.73877 4.46275 3.63613 4.87088L3.35144 6.00909H2.52115V2.64884ZM12.0606 6.50273C12.002 6.57728 11.914 6.62004 11.8193 6.62004H9.54713C9.37911 6.62004 9.24165 6.48317 9.24165 6.31455V5.09266C9.24165 4.92403 9.37911 4.78717 9.54713 4.78717H11.5144C11.6549 4.78717 11.7765 4.88188 11.8107 5.01811L12.1162 6.24003C12.1394 6.33228 12.1193 6.42759 12.0606 6.50273ZM6.79846 5.09266V6.31151C6.79846 6.31275 6.79786 6.31335 6.79786 6.31458C6.79786 6.31518 6.79786 6.31581 6.79786 6.31581C6.79726 6.48383 6.66039 6.62007 6.493 6.62007H4.22085C4.12554 6.62007 4.03816 6.57731 3.97951 6.50276C3.92086 6.42762 3.9007 6.3317 3.92392 6.24006L4.22941 5.01814C4.26363 4.88251 4.3852 4.7872 4.52633 4.7872H6.493C6.661 4.78717 6.79846 4.92403 6.79846 5.09266ZM2.4411 6.62004H3.3606C3.39299 6.71168 3.43515 6.79966 3.49683 6.87907C3.67279 7.10268 3.93612 7.23098 4.22022 7.23098H6.49237C6.8901 7.23098 7.22612 6.97438 7.35259 6.62004H8.68692C8.81339 6.97501 9.1494 7.23098 9.54713 7.23098H11.8193C12.1034 7.23098 12.3661 7.10268 12.542 6.87907C12.6038 6.80026 12.6459 6.71168 12.6783 6.62004H13.5984L14.5417 9.68583C14.5063 9.68156 14.4715 9.67483 14.4348 9.67483H1.60471C1.56806 9.67483 1.53323 9.68156 1.49841 9.68583L2.4411 6.62004ZM1.9102 13.9515H1.29922V13.3406H1.91017V13.9515H1.9102ZM14.7403 13.9515H14.1293V13.3406H14.7403V13.9515ZM14.7403 12.7296H1.29922V10.5913C1.29922 10.4226 1.43669 10.2858 1.60471 10.2858H14.4348C14.6028 10.2858 14.7403 10.4226 14.7403 10.5913V12.7296Z"
                                    fill="#0F80F2"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_90_199">
                                    <rect
                                        width="14.6629"
                                        height="14.6629"
                                        fill="white"
                                        transform="translate(0.688309 0.510376)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <div className="text-[#262525] text-xs 3xl:text-sm">
                            {product.numero_habitaciones} Dormitorios
                        </div>
                    </div>

                    <div className="flex items-center justify-center gap-1">
                        <svg
                            className="w-4 h-4"
                            viewBox="0 0 15 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_90_191)">
                                <path
                                    d="M13.9621 7.23132H1.74299V2.08096C1.74299 1.73272 2.0668 1.42723 2.43641 1.42723H3.71332C4.0738 1.42723 4.36399 1.72049 4.36705 2.0779C3.77137 2.22759 3.2704 2.77745 3.2704 3.35784V4.17653C3.2704 4.34456 3.40786 4.48202 3.57589 4.48202H5.71421C5.88224 4.48202 6.0197 4.34456 6.0197 4.17653V3.35787C6.0197 2.76829 5.55232 2.22759 4.97803 2.08096C4.97803 1.38447 4.4129 0.816284 3.71335 0.816284H2.43644C1.73079 0.816284 1.13204 1.3967 1.13204 2.08096V7.23132C0.628002 7.22826 0.218671 7.63762 0.215607 8.14166C0.215607 8.40436 0.325579 8.6518 0.521094 8.82592V10.4266C0.521094 11.6699 1.07402 12.736 1.96906 13.4295L1.46809 14.4253C1.39171 14.575 1.45282 14.7583 1.60555 14.8346C1.75524 14.911 1.93853 14.8499 2.01488 14.6972L2.48533 13.7593C3.1024 14.0893 3.79276 14.2603 4.49232 14.2542H10.6019C11.3014 14.2603 11.9918 14.0893 12.6089 13.7593L13.0793 14.6972C13.1557 14.8469 13.339 14.9079 13.4886 14.8346C13.6383 14.7613 13.6994 14.575 13.6261 14.4253L13.1251 13.4264C14.0202 12.736 14.5731 11.6668 14.5731 10.4236V8.82286C14.7655 8.65483 14.8786 8.40739 14.8786 8.14776C14.8786 7.64068 14.4692 7.23132 13.9621 7.23132ZM4.67254 2.64915C5.03605 2.64915 5.40875 3.00656 5.40875 3.35787V3.87107H3.88134V3.35787C3.88134 3.01879 4.29374 2.64915 4.67254 2.64915ZM13.9621 10.4266C13.9621 12.2626 12.5172 13.6464 10.6019 13.6464H4.49229C2.57694 13.6464 1.13204 12.2625 1.13204 10.4266V9.06422H13.9621V10.4266ZM13.9621 8.45325H1.14121C0.988476 8.45325 0.851011 8.34327 0.829618 8.19358C0.802125 8.00419 0.948754 7.84227 1.13204 7.84227H13.953C14.1057 7.84227 14.2432 7.95224 14.2645 8.10194C14.292 8.29135 14.1454 8.45325 13.9621 8.45325Z"
                                    fill="#0F80F2"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_90_191">
                                    <rect
                                        width="14.6629"
                                        height="14.6629"
                                        fill="white"
                                        transform="translate(0.215607 0.510376)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <div className="text-[#262525] text-xs 3xl:text-sm">
                            {product.numero_banos} Baños
                        </div>
                    </div>
                </div>
                <div className="text-xs md723:flex hidden gap-1 text-[#053465] mt-4 flex-wrap">
                    {atributos.map((atributo, index) => (
                        <span key={index}>
                            {atributo}
                            {index < atributos.length - 1 && " • "}
                        </span>
                    ))}
                </div>
                {selectedDays.length > 0 && (
                    <div className="md723:flex md723:flex-col  justify-start items-start text-[#053465] gap-1 hidden md723:absolute bottom-2 ">
                        <span className="font-bold 3xl:text-sm text-xs italic">
                            (precio referencial)
                        </span>
                        <div className="flex justify-center items-center">
                            <span className="font-bold 3xl:text-3xl lg:text-2xl">
                                {moneda_elegida === "PEN" ? "S/" : "$"}{" "}
                                {numberToCommas(
                                    getTotalReservaFinal(
                                        cantDays + 1,
                                        selectedDays,
                                        {
                                            ...product,
                                            huespedes: personas,
                                        },
                                        getPreciosAdicionales({
                                            ...product,
                                            huespedes: personas,
                                        }),
                                        authUser.tipo_usuario === 6 ||
                                            authUser.tipo_usuario === 7,
                                        getGarantiaTotal,
                                        authUser.membresia,
                                        true
                                    ) -
                                        calcularDescuentoPrecioFinal(
                                            getTotalReservaInicial(
                                                cantDays + 1,
                                                selectedDays,
                                                {
                                                    ...product,
                                                    huespedes: personas,
                                                }
                                            ),
                                            product.oferta_activada,
                                            product.oferta
                                        ) -
                                        getTotalReservaInicial(
                                            cantDays + 1,
                                            selectedDays,
                                            {
                                                ...product,
                                                huespedes: personas,
                                            },
                                            true
                                        )
                                )}
                            </span>
                            <span className="lg:text-base 3xl:text-lg">
                                / Por {cantDays} noches
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardsDestacados;
